<template>
	<div></div>
</template>

<script>
export default {
	name: 'blank'
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/other/blank.vue